export default __webpack_public_path__ + "6d1e99afee734d35494a7e8e01043ecf.jpg";